import React, { useEffect, useState } from 'react'
import { supabase } from '../lib/supabase'
import { clearTariffeCache } from '../lib/dataloader'

const PACCHETTI = ['BASE', 'ADVANCED']
const DURATE = [24, 36, 48, 60]

export default function AdminLloydVolanteTassi() {
  const [tassi, setTassi] = useState([])
  const [edits, setEdits] = useState({})
  const [loading, setLoading] = useState(true)
  const [saving, setSaving] = useState(false)

  useEffect(() => { load() }, [])
  async function load() {
    setLoading(true)
    const { data } = await supabase.from('lloyd_volante_tassi').select('*')
    setTassi(data || [])
    setLoading(false)
  }

  function k(pacchetto, durata) { return `${pacchetto}||${durata}` }

  function getVal(pacchetto, durata) {
    const key = k(pacchetto, durata)
    if (edits[key] !== undefined) return edits[key]
    const row = tassi.find(t => t.pacchetto === pacchetto && t.durata_mesi === durata)
    return row != null ? row.tasso : ''
  }

  async function saveAll() {
    setSaving(true)
    for (const [key, val] of Object.entries(edits)) {
      const [pacchetto, durata] = key.split('||')
      await supabase.from('lloyd_volante_tassi')
        .update({ tasso: parseFloat(val) })
        .eq('pacchetto', pacchetto)
        .eq('durata_mesi', parseInt(durata))
    }
    setEdits({})
    clearTariffeCache()
    await load()
    setSaving(false)
  }

  if (loading) return <div className="loading">Caricamento...</div>
  const dirty = Object.keys(edits).length > 0

  return (
    <div>
      <div className="page-header flex-between">
        <div>
          <h1>Tassi Lloyd's Volante</h1>
          <p>Tassi per pacchetto × durata (solo Campania). Unità: €/1000€ assicurati. Formula: tasso × valore + 30% broker + commissione.</p>
        </div>
        {dirty && (
          <button className="btn btn-primary" onClick={saveAll} disabled={saving}>
            {saving ? 'Salvataggio...' : `Salva ${Object.keys(edits).length} modifiche`}
          </button>
        )}
      </div>

      <div className="card">
        <div className="table-wrap">
          <table>
            <thead>
              <tr>
                <th>Pacchetto</th>
                {DURATE.map(d => <th key={d}>{d} mesi</th>)}
              </tr>
            </thead>
            <tbody>
              {PACCHETTI.map(p => (
                <tr key={p}>
                  <td><strong>{p}</strong></td>
                  {DURATE.map(d => {
                    const key = k(p, d)
                    const val = getVal(p, d)
                    const isDirty = edits[key] !== undefined
                    return (
                      <td key={d}>
                        <input
                          type="number" step="0.0001" value={val}
                          onChange={e => setEdits(s => ({ ...s, [key]: e.target.value }))}
                          style={{ width: 100, background: isDirty ? '#FFF7E5' : 'transparent' }}
                        />
                      </td>
                    )
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}
